import { useRef } from "react";
import { useTrans } from "../../hooks";
import {
    Button,
    HStack,
    Popover,
    PopoverBody,
    PopoverContent,
    PopoverHeader,
    PopoverTrigger,
    useBreakpointValue,
} from "@chakra-ui/react";

export type AppFilterContainerProps = {
    children: JSX.Element;
    onReset: () => void;
    triggerElement: JSX.Element;
    setIsInit?: (isInit: boolean) => void;
    isModalOpen?: boolean;
    zIndex?: string;
};

export const AppFilterContainer = ({
    children,
    onReset,
    triggerElement,
    setIsInit,
    isModalOpen = false,
    zIndex = "1500",
}: AppFilterContainerProps) => {
    const { t } = useTrans();
    const initRef = useRef(null);
    const popoverWidth = useBreakpointValue({
        base: "90vw",
        sm: "90vw",
        md: "600px",
    });

    return (
        <Popover
            initialFocusRef={initRef}
            placement="bottom-end"
            closeOnBlur={!isModalOpen}
            modifiers={[
                {
                    name: "zIndex",
                    enabled: zIndex !== "1500",
                    phase: "write",
                    fn: ({ state }) => {
                        state.elements.popper.style.zIndex = zIndex;
                    },
                },
            ]}
        >
            {({ isOpen, onClose }) => {
                if (setIsInit && isOpen) {
                    setIsInit(isOpen);
                }
                return (
                    <>
                        <PopoverTrigger>{triggerElement}</PopoverTrigger>
                        {isOpen && (
                            <PopoverContent
                                w={popoverWidth}
                                bg={"var(--chakra-colors-white)"}
                                sx={{
                                    boxShadow:
                                        "var(--chakra-colors-boxShadowPrimary)",
                                }}
                                justifyContent={{ base: "center" }}
                            >
                                <PopoverHeader
                                    bg={"var(--chakra-colors-primaryT95)"}
                                    textStyle={"mediumMd"}
                                >
                                    {t("cmn:title.filter")}
                                </PopoverHeader>
                                <PopoverBody px={"1rem"} py={"1.5rem"}>
                                    {children}
                                </PopoverBody>
                                <HStack
                                    bg={"var(--chakra-colors-primaryT95)"}
                                    borderTop={
                                        "1px solid var(--chakra-colors-primaryT85)"
                                    }
                                    justifyContent={"space-between"}
                                    p={4}
                                >
                                    <Button
                                        size={"sm"}
                                        variant={"outline"}
                                        onClick={() => {
                                            onReset();
                                            onClose();
                                        }}
                                    >
                                        {t("cmn:button.reset")}
                                    </Button>
                                    <Button
                                        size={"sm"}
                                        type="submit"
                                        form="app-filter-form"
                                        onClick={() => {
                                            setTimeout(() => {
                                                onClose();
                                            }, 500);
                                        }}
                                    >
                                        {t("cmn:button.apply")}
                                    </Button>
                                    {/* <Button
                                    size={"sm"}
                                    onClick={() => {
                                        const form = document.getElementById(
                                            "app-filter-form"
                                        ) as HTMLFormElement;
                                        form?.requestSubmit();
                                        onClose();
                                    }}
                                >
                                    {t("cmn:button.apply")}
                                </Button> */}
                                </HStack>
                            </PopoverContent>
                        )}
                    </>
                );
            }}
        </Popover>
    );
};
